// Dashboard widget types
export type DashboardWidgetType =
  | 'invoice_summary'
  | 'incomplete_invoices'
  | 'incomplete_vouchers'
  | 'incomplete_specialized_vouchers'
  | 'tasks'
  | 'document_alerts'
  | 'woocommerce_orders';

// Widget configuration
export interface WidgetConfig {
  id: DashboardWidgetType;
  title: string;
  description: string;
  icon: string;
  color: string;
  enabled: boolean;
  order: number;
}

// Invoice summary data
export interface InvoiceSummaryData {
  sales: number;
  salesCount: number;
  returns: number;
  returnsCount: number;
  netSales: number;
  chartData: Array<{
    name: string;
    sales: number;
    returns: number;
    net: number;
  }>;
  period: 'day' | 'week' | 'month';
  dateRange: {
    start: Date;
    end: Date;
  };
}

// Incomplete invoice item
export interface IncompleteInvoice {
  _id: string;
  invoiceNumber: string;
  date: string;
  customerName: string;
  total: number;
  remaining?: number; // المبلغ المتبقي من الفاتورة
  status: string;
  type?: string; // نوع الفاتورة (sales, purchase, sales-return, purchase-return)
  pageId?: string; // معرف صفحة الفاتورة (مطلوب للرابط الصحيح)
  branchName?: string;
}

// Voucher item (receipt/payment)
export interface VoucherItem {
  _id: string;
  voucherNumber: string;
  type: 'receipt' | 'payment';
  date: string;
  fromTo: string;
  amount: number;
  status: string;
  branchName?: string;
}

// Specialized voucher item
export interface SpecializedVoucherItem {
  _id: string;
  voucherNumber: string;
  type: string;
  date: string;
  description: string;
  amount: number;
  status: string;
  branchName?: string;
}

// Task item
export interface TaskItem {
  _id: string;
  title: string;
  description?: string;
  priority: 'high' | 'medium' | 'low';
  status: 'pending' | 'in_progress' | 'completed';
  dueDate?: string;
  assignedTo?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

// Task form data
export interface TaskFormData {
  title: string;
  description?: string;
  priority: 'high' | 'medium' | 'low';
  dueDate?: string;
  assignedTo?: string;
}

// WooCommerce order item
export interface WooCommerceOrderItem {
  _id: string;
  wooOrderId: number;
  orderNumber: string;
  status: string;
  importStatus: string;
  customerFullName: string;
  totals: {
    total: number;
    currency: string;
  };
  dateCreated: string;
  convertedToInvoice: boolean;
  invoiceId?: {
    _id: string;
    invoiceNumber: string;
    pageId: string;
  };
  shippingBillNumber?: string;
}

// Widget data types
export interface WidgetData {
  invoice_summary?: InvoiceSummaryData;
  incomplete_invoices?: IncompleteInvoice[];
  incomplete_vouchers?: VoucherItem[];
  incomplete_specialized_vouchers?: SpecializedVoucherItem[];
  tasks?: TaskItem[];
  document_alerts?: any[];
  woocommerce_orders?: WooCommerceOrderItem[];
}

// Available widgets list
export const AVAILABLE_WIDGETS: WidgetConfig[] = [
  {
    id: 'invoice_summary',
    title: 'ملخص الفواتير',
    description: 'إحصائيات شاملة للفواتير مع الرسم البياني',
    icon: '📊',
    color: '#3498db',
    enabled: true,
    order: 1
  },
  {
    id: 'incomplete_invoices',
    title: 'الفواتير الغير مكتملة',
    description: 'قائمة بالفواتير التي تحتاج إلى إكمال',
    icon: '⚠️',
    color: '#e74c3c',
    enabled: true,
    order: 2
  },
  {
    id: 'incomplete_vouchers',
    title: 'السندات الغير مكتملة',
    description: 'سندات الصرف والقبض الغير مكتملة',
    icon: '💰',
    color: '#f39c12',
    enabled: true,
    order: 3
  },
  {
    id: 'incomplete_specialized_vouchers',
    title: 'السندات المتخصصة',
    description: 'السندات المتخصصة الغير مكتملة',
    icon: '📋',
    color: '#9b59b6',
    enabled: true,
    order: 4
  },
  {
    id: 'tasks',
    title: 'المهام',
    description: 'قائمة المهام والتذكيرات',
    icon: '✅',
    color: '#27ae60',
    enabled: true,
    order: 5
  },
  {
    id: 'document_alerts',
    title: 'تنبيهات المستندات',
    description: 'المستندات القريبة من الانتهاء (14 يوم أو أقل)',
    icon: '🔔',
    color: '#f39c12',
    enabled: true,
    order: 6
  },
  {
    id: 'woocommerce_orders',
    title: 'طلبات WooCommerce',
    description: 'الطلبات المستوردة قيد الانتظار أو المعالجة',
    icon: '🛒',
    color: '#7c3aed',
    enabled: true,
    order: 7
  }
];